module.exports = __webpack_public_path__ + "img/full_thumb_sample_4.d7898664.png";